import React, { useMemo } from 'react';
import clsx from 'clsx';
import { isNil } from 'lodash';
import { ALLOCATIONS_DRAFT } from 'common/constants/allocations';
import { useAllocationValuesStore } from 'store';
import { ALLOCATION_STATUS } from './common/constants';
import { StyledGrid, StyledTypography } from './styles';
import { AllocationStatusBadgeProps } from './types';

const AllocationStatusBadge = (props: AllocationStatusBadgeProps) => {
  const { status } = props;

  // Allocation Values Store
  const currentAllocationStatus = useAllocationValuesStore(state => state.currentAllocationStatus);

  const shouldDisplayBadge = useMemo(
    () => !isNil(status) || !isNil(currentAllocationStatus),
    [currentAllocationStatus, status]
  );

  const allocationStatus = useMemo(
    () => ALLOCATION_STATUS[status ?? currentAllocationStatus ?? ALLOCATIONS_DRAFT],
    [currentAllocationStatus, status]
  );

  if (!shouldDisplayBadge) {
    return null;
  }

  return (
    <StyledGrid className={clsx(allocationStatus)} data-testid={`allocation-status-badge-${allocationStatus}`}>
      <StyledTypography className={clsx(allocationStatus)}>{allocationStatus}</StyledTypography>
    </StyledGrid>
  );
};

export default AllocationStatusBadge;
